// Generated by Copilot
import { useAuth, useUser } from '@clerk/react';
import { useCallback } from 'react';

const CLERK_JWT_TEMPLATE = 'jwt-userfront-mapping';

/**
 * Custom hook that provides authentication headers for API calls.
 * Returns the Clerk session token (via jwt-userfront-mapping template)
 * and the user's external ID (mapped from Userfront userUuid).
 */
const useAuthHeaders = () => {
  const { getToken, isSignedIn, isLoaded } = useAuth();
  const { user } = useUser();

  // externalId is the Userfront userUuid set during migration via Clerk's external_id field
  const userId = user?.externalId || user?.id;
  const email = user?.primaryEmailAddress?.emailAddress || '';

  const getAuthHeaders = useCallback(async () => {
    const token = await getToken({ template: CLERK_JWT_TEMPLATE });
    return {
      'Authorization': `Bearer ${token}`,
    };
  }, [getToken]);

  const getTokenValue = useCallback(async () => {
    return await getToken({ template: CLERK_JWT_TEMPLATE });
  }, [getToken]);

  return {
    userId,
    email,
    isSignedIn,
    isLoaded,
    getAuthHeaders,
    getToken: getTokenValue,
  };
};

export default useAuthHeaders;
